import { faCheck, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { Alert, Button, ButtonGroup, Modal } from 'rsuite';
import { authHeader } from '../../../redux/helpers';
import { axiosService } from '../../../redux/services';

type Props = {
    intl: Record<string, any>;
    event: Record<string, any>;
    onHide: Function;
    reloadEvents: Function;
    show: boolean;
} & WrappedComponentProps;

type State = {
    isDeleting: boolean;
    hasError: boolean;
    loading: boolean;
};

class DeleteEventModal extends React.Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            isDeleting: false,
            hasError: false,
            loading: false,
        };

        this.handleDeleteEvent = this.handleDeleteEvent.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    /**
     * Launch delete request from axios
     */
    handleDeleteEvent() {
        this.setState({
            isDeleting: true,
            hasError: false,
        });
        // Define headers and eventId to delete event
        const data = {
            headers: authHeader(),
            data: { id: this.props.event.id },
        };

        axiosService
            .getAxios()
            .delete('/event-actions/event', data)
            .then(() => {
                Alert.success(
                    this.props.intl.formatMessage({
                        id: 'event.deleteSuccess',
                    })
                );

                this.props.onHide();
                this.props.reloadEvents();
            })
            .catch(err => {
                console.error(err);

                Alert.error(
                    this.props.intl.formatMessage({
                        id: 'event.deleteError',
                    })
                );

                this.setState({
                    hasError: true,
                });
            })
            .finally(() => {
                this.setState({
                    isDeleting: false,
                });
            });
    }

    closeModal() {
        this.props.onHide();
    }

    render() {
        return (
            <Modal backdrop="static" show={this.props.show} onHide={this.closeModal}>
                <Modal.Header>
                    <Modal.Title>
                        <FormattedMessage id="event.delete.title" />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormattedMessage id="event.delete.message" />
                </Modal.Body>
                <Modal.Footer>
                    <ButtonGroup>
                        <Button
                            onClick={this.closeModal}
                            data-cy="event-deleteModal-cancel"
                            color="red"
                            loading={this.state.loading}>
                            <FontAwesomeIcon icon={faTimesCircle} />
                        </Button>
                        <Button
                            onClick={this.handleDeleteEvent}
                            data-cy="event-deleteModal-valid"
                            appearance="primary"
                            loading={this.state.loading}>
                            <FontAwesomeIcon icon={faCheck} />
                        </Button>
                    </ButtonGroup>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default injectIntl(DeleteEventModal);
